// FNP-783: the "My Applications" enable-list must show only public/business
// apps — never ADMIN consoles (Admin/Stripe/Billing/Marketplace). console-api
// listApplications supports server-side filtering via ApplicationsFilterInput;
// the portal now declares $filter and passes it (was an unfiltered query that
// rendered every application, incl. admin consoles — the FNP-782 incident's
// proximate cause). applicationCategory is selected so the client can also
// defensively exclude ADMIN.
export const listApplications = `
   query listApplications($filter: ApplicationsFilterInput) {
       listApplications(filter: $filter) {
           items {
              id
              name
              description
              url
              logoUrl
              applicationCategory
              created
              updated
           }
       }
   }
`;

export const getApplication = `
   query getApplication($id:ID!) {
       getApplication(id:$id) {
         id
         name
         description
         url
         logoUrl
         created
         updated
       } 
}`;
